import { timeQuery } from 'helpers/Utils';
var Article = /** @class */ (function () {
    function Article(props) {
        Object.assign(this, props);
        this.updated = new Date(props.updated);
        this.image = timeQuery(props.image, this.updated);
    }
    return Article;
}());
export { Article };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Articles/Model.ts
// module id = 679
// module chunks = 0